import styled from 'styled-components'

export const PageContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const SummaryGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;

  @media (max-width: 980px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`

export const HeaderRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`

export const SummaryCard = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 22px;
  color: #1f2124;
`

export const SummaryRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const SummaryLabel = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #797a7c;
`

export const SummaryValue = styled.span`
  font-size: 16px;
  color: #1f2124;
  white-space: pre-wrap;
`

export const Badge = styled.span<{ statusColor?: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  min-width: 110px;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => props.statusColor || '#2d749c'};
  background: rgba(45, 116, 156, 0.12);
`

export const QuestionsContainer = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`

export const QuestionCard = styled.div`
  border: 1px solid rgba(45, 116, 156, 0.16);
  border-radius: 16px;
  padding: 20px;
  background: #f9fbff;
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const QuestionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
`

export const QuestionTitle = styled.h4`
  margin: 0;
  font-size: 18px;
  color: #1f2124;
`

export const MetaRow = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`

export const MetaTag = styled.span`
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(198, 1, 107, 0.08);
  color: #c6016b;
  font-size: 13px;
  font-weight: 700;
`

export const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const OptionItem = styled.div`
  padding: 12px 14px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid rgba(31, 33, 36, 0.08);
  color: #1f2124;
`

export const EmptyState = styled.div`
  padding: 24px;
  border-radius: 16px;
  background: rgba(45, 116, 156, 0.06);
  color: #4d4f52;
  font-size: 16px;
`

export const ModulesContainer = styled.div`
  max-width: 1400px;
  display: grid;
  grid-template-columns : repeat(3, 1fr);;
  gap: 16px;
  @media (max-width: 980px)  {
    grid-template-columns : repeat(2, 1fr);;
  }
  @media (max-width: 680px)  {
    grid-template-columns : repeat(1, 1fr);;
  }
`
export const Card = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  display: flex;
  flex-direction: row; 
  width: 85%;
  height: 92px;
  padding: 12px;
  
`

export const CardDescriptionSection = styled.div`
  margin: 10px;
`
export const Icon = styled.img`
  max-width: 60px;
`

export const UploadSizeRecomended = styled.p`
  width:174px;
  color: #797A7C;
  font-weight: 100;
  font-size: 16px;
`
